module.exports = __webpack_public_path__ + "img/weddings_24_H.f48e3189.webp";